import React from 'react';
import { Card } from 'react-bootstrap';

const DataTableViewMobile = ({ data, mobileCardRenderer, mobileActions }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-5 text-muted d-block d-lg-none">
        <i className="bi bi-search display-6 mb-3"></i>
        <p className="mb-1">No se encontraron resultados</p>
      </div>
    );
  }

  const getUniqueKey = (item, index) => {
    if (item.id_usuario) return `user-${item.id_usuario}-${index}`;
    if (item.id_formulario) return `form-${item.id_formulario}-${index}`;
    return `card-${index}`;
  };

  return (
    <div className="d-block d-lg-none">
      {data.map((item, index) => (
        <Card key={getUniqueKey(item, index)} className="mb-3 shadow-sm">
          <Card.Body>
            {mobileCardRenderer ? (
              mobileCardRenderer(item)
            ) : (
              <div className="text-center py-3">
                <span className="text-muted">Configure mobileCardRenderer prop</span>
              </div>
            )}
            {mobileActions && (
              <div className="mt-3 pt-2 border-top">
                {mobileActions(item)}
              </div>
            )}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default React.memo(DataTableViewMobile);